<template>
  <div class="pt-1">
    <table class="table">
      <tbody>
        <tr>
          <td><strong>Người tạo:</strong></td>
          <td>{{ (dataEdit.user_info) ? dataEdit.user_info.full_name : '' }}</td>
        </tr>
        <tr>
          <td><strong>Ngày gửi:</strong></td>
          <td>{{ dataEdit.created_at }}</td>
        </tr>
        <tr>
          <td><strong>Nôi dung:</strong></td>
          <td style="vertical-align: top;">
            <p class="mb-0">{{ dataEdit.content }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="2"
            class="text-center pb-0">
            <b-button size="sm"
              variant="danger"
              @click="onDestroy(dataEdit)">
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" /> Xóa </span>
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import {
  BCard, BLink, BButton, BRow, BCol, BForm, BFormInput, BFormInvalidFeedback, BFormCheckbox, BFormGroup,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import store from '@/store'
import { showToast } from '@core/utils/utils';

export default {
  components: {
    BCol,
    BRow,
    BButton,
    BCard,
    BFormGroup,
    BForm,
    BFormInput,
    BFormCheckbox,
    BLink,
    BFormInvalidFeedback,
  },
  props: {
    dataEdit: {
      type: Object,
      default: null
    },

  },
  setup(props, context) {

    return {
    }
  },

  methods: {
    onDestroy(item) {
      this.$swal({
        title: '',
        text: 'Bạn có chắc chắn muốn xóa bình luận này không?',
        showCancelButton: true,
        cancelButtonText: 'Hủy',
        confirmButtonText: 'Đồng ý',
        customClass: {
          cancelButton: 'btn btn-secondary ml-1 btn-sm',
          confirmButton: 'btn btn-success btn-sm',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          const { id } = item
          store.dispatch('comment/destroy', id)
            .then(response => {
              const rs = response.data
              if (rs.code === 200) {
                showToast(rs.message, { variant: 'success' })
                this.$emit('updateList');
              } else {
                showToast(rs.message)
              }

            })
        }
      })
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
